import { ExpandableSection, Table } from 'AWS-UI-Components-React';
import React from 'react';
import { ASIN_METRIC_TYPE, COMPONENT_NAMES, DEFAULT_TREND_WEEKS } from '../../../constants/asin_metric_elements';
import { CHANNELS } from '../../../constants/channels';
import { formatTimeFrameToYYYYMM } from '../../../utils/date-utils';
import { EmptyMessage } from '../../content/empty_message';
import { TEXT } from '../common/constants';
import { getAsinMetricsClient } from './asin_metrics_client';
import { getColumnDefinitions, getComponentMetricMap, getTrendGraphSnapshotMap, mergeKeysOfObjectsWithSameId } from './asin_metrics_utils';

export class AsinInfoTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingAsinMetrics: false,
      loadError: false,
      asinMetricRows: [],
      asinModalVisible: false,
      trendDataRows: [],
      trendLines: [],
      asin: "",
    };
  }

  componentDidMount = () => {
    this.initialClientTasks();
  };

  initialClientTasks = () => {
    this.asinMetricsClient = getAsinMetricsClient();
  };

  onAsinRowClick = (event) => {
    if(event.detail.item){
      const asin = event.detail.item.ASIN;
      this.setState({loadingAsinMetrics: true, asinModalVisible: true, asin});
      this.pullAsinMetrics(asin);
    }
  }

  pullAsinMetrics = (asin) => {
    //Backend only accepts Retail not RETAIL
    const channel = CHANNELS.RETAIL === this.props.payload.channel ? 'Retail' : this.props.payload.channel;
    //TODO remove gl from request
    const gl = this.props.payload.gls && this.props.payload.gls.length > 0 && this.props.payload.gls[0];
    const payload = {marketplaceId: this.props.payload.marketplace, channel, components: [this.props.component],
      month:formatTimeFrameToYYYYMM(this.props.payload.timeFrame), gl, asin, trendPeriodInWeeks: DEFAULT_TREND_WEEKS};
    this.asinMetricsClient.getAsinMetrics(this.processAsinMetrics, this.onFailedRequest, payload);
  }

  processAsinMetrics = (response) => {
    if (response.data && response.data.asinMetricItems && response.data.asinMetricItems.length) {
      const asinMetricItems = response.data.asinMetricItems;
      this.processTrendGraphData(asinMetricItems);
      const [snapshotToComponentMetricMap, latestSnapshot] = getComponentMetricMap(asinMetricItems);
      const componentToMetricsMap = snapshotToComponentMetricMap.has(latestSnapshot) ?
                                    snapshotToComponentMetricMap.get(latestSnapshot) : new Map();
      const reportRows = [];
      for (const [key, value] of componentToMetricsMap.entries()){
        reportRows.push({component: key, [ASIN_METRIC_TYPE.NET_FA]: value.get(ASIN_METRIC_TYPE.NET_FA),
                          [ASIN_METRIC_TYPE.NET_LA]: value.get(ASIN_METRIC_TYPE.NET_LA)});
      }
      this.setState({asinMetricRows:reportRows});

    }
  }

  processTrendGraphData = (asinMetricItems) => {
    const snapshotMap = getTrendGraphSnapshotMap(asinMetricItems);
    const trendDataRows = [];
    let uniqueTrendLines = new Set();
    for(const key of snapshotMap.keys()){
      trendDataRows.push(snapshotMap.get(key));
      Object.keys(snapshotMap.get(key)).filter(k => k !== 'snapshot').forEach(lineId => {
        uniqueTrendLines.add(lineId);
      });
    }
    //Merge keys of trendDataRow with the same snapshotDate
    const combinedRows = mergeKeysOfObjectsWithSameId(trendDataRows, 'snapshot');
    this.setState({trendDataRows: combinedRows, trendLines: [...uniqueTrendLines], loadingAsinMetrics: false});
  }

  onFailedRequest = () => {
    this.setState({loadError: true});
  };

  onCloseAsinMetricModel = () => {
    this.setState({asinModalVisible: false});
  }

  render() {
    const {tableName, items, loading, displayInMillions, component} = this.props;
    const componentName = component && component.length ? COMPONENT_NAMES[component] : '';
    return (
      <div>
        <ExpandableSection header={`${tableName}: ${componentName}`} expanded={loading || items.length > 0}>
          <Table
            className="ZebraStripesTable accuracy-table-container"
            columnDefinitions={getColumnDefinitions(items, this.props.displayInMillions)}
            items={items}
            loadingText={TEXT.LOADING}
            loading={loading}
            stickyHeader={true}
            wrapLines={false}
            // onRowClick={this.onAsinRowClick}
            empty={<EmptyMessage />}
          />
        </ExpandableSection>
        {/*{this.state.asinModalVisible && <AsinMetricModal items={this.state.asinMetricRows} loading={this.state.loadingAsinMetrics}*/}
        {/*                                                 displayInMillions={displayInMillions} onClose={this.onCloseAsinMetricModel}*/}
        {/*                                                 asin={this.state.asin} component={this.props.component}*/}
        {/*                                                 trendDataRows={this.state.trendDataRows}*/}
        {/*                                                 trendLines={this.state.trendLines}/>}*/}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/asin_metrics/asin_info_table.jsx